import React from 'react';
import { getOrgBadgeClass } from '../../lib/orgConfig';
import SpeakerImage from './SpeakerImage';
import SpeakerTopics from './SpeakerTopics';
import SpeakerSocialLinks from './SpeakerSocialLinks';
import SpeakerActions from './SpeakerActions';

const SpeakerHero = ({ speaker, isFavorite, onToggleFavorite, onInvite, onClickTopic }) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl overflow-hidden border border-gray-100 dark:border-gray-700">
      <div className="md:flex">
        {/* Image */}
        <div className="md:w-64 lg:w-72 flex-shrink-0">
          <div className="aspect-square bg-gradient-to-br from-purple-100 to-amber-50 dark:from-purple-900/30 dark:to-amber-900/20">
            <SpeakerImage
              speaker={speaker}
              size="full"
              rounded=""
              className="w-full h-full"
            />
          </div>
        </div>

        {/* Info */}
        <div className="p-4 md:p-6 flex-1">
          {/* Header */}
          <div className="border-b border-gray-100 dark:border-gray-700 pb-4 mb-4">
            <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-3">
              <div className="flex-1">
                <h1 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white tracking-tight">
                  {speaker.name}
                </h1>

                {speaker.title && (
                  <p className="mt-1 text-base md:text-lg text-primary font-medium">
                    {speaker.title}
                  </p>
                )}

                {/* Location */}
                {(speaker.city || speaker.state || speaker.church_city || speaker.church_state) && (
                  <p className="mt-2 text-sm text-gray-500 dark:text-gray-400 flex items-center gap-1.5">
                    <svg className="w-4 h-4 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    {[speaker.city || speaker.church_city, speaker.state || speaker.church_state].filter(Boolean).join(', ')}
                  </p>
                )}

                {/* Badges */}
                <div className="mt-4 flex items-center gap-2 flex-wrap">
                  {speaker.organization && (
                    <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold ${getOrgBadgeClass(speaker.organization)}`}>
                      {speaker.organization}
                    </span>
                  )}
                  {speaker.is_verified && (
                    <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800 dark:bg-green-900/50 dark:text-green-300">
                      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      Verified Speaker
                    </span>
                  )}
                </div>

                {/* Topic chips */}
                {speaker.topics && speaker.topics.length > 0 && (
                  <div className="mt-3">
                    <SpeakerTopics topics={speaker.topics} max={5} onClickTopic={onClickTopic} />
                  </div>
                )}
              </div>

              {/* Social links */}
              <SpeakerSocialLinks speaker={speaker} variant="col" />
            </div>

            {/* Actions */}
            <div className="mt-6">
              <SpeakerActions
                speaker={speaker}
                isFavorite={isFavorite}
                onToggleFavorite={onToggleFavorite}
                onInvite={onInvite}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpeakerHero;
